var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect2, _rect3, _rect4, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationsError1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 136,
    fill: "none",
    viewBox: "0 0 128 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M63.178 135.018c34.802 0 63.015-28.432 63.015-63.504S97.98 8.01 63.178 8.01C28.375 8.01.163 36.44.163 71.514c0 35.072 28.212 63.504 63.015 63.504z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#04A",
    d: "M39.557 114.528c.136-2.778 2.41-4.96 5.17-4.961h37.612c2.761-.004 5.037 2.181 5.169 4.961h-47.95z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M23.35 117.812c.003 1.022.065 2.042.187 3.056a62.639 62.639 0 0 0 79.291 0c.122-1.014.185-2.034.187-3.056v-4.822H23.35v4.822z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#003CC1",
    d: "M51.46 103.841h23.445v9.873H51.46v-9.873z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M97.925 69.03a7.16 7.16 0 0 1 7.16-7.16h1.158a7.16 7.16 0 0 1 7.16 7.16v4.482a7.16 7.16 0 0 1-7.16 7.16h-1.158a7.16 7.16 0 0 1-7.16-7.16V69.03z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.478,
    height: 18.803,
    x: 12.973,
    y: 61.869,
    fill: "url(#d)",
    rx: 7.16
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M106.078 70.085c0 23.318-19.141 37.16-42.743 37.16-23.6 0-42.742-13.892-42.742-37.16 0-23.268 19.131-42.23 42.742-42.23 23.611 0 42.743 18.902 42.743 42.23z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M103.341 68.15c0 22.246-17.605 35.453-39.326 35.453-21.72 0-39.326-13.236-39.326-35.453 0-22.216 17.605-40.295 39.326-40.295 21.72 0 39.326 18.039 39.326 40.295z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D6DCC",
    d: "M94.715 65.769c0 15.112-14.05 24.072-31.38 24.072-17.328 0-31.379-8.93-31.379-24.072s14.05-27.367 31.38-27.367c17.329 0 31.38 12.275 31.38 27.367z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4FAFF",
    d: "M94.715 64.628c0 14.486-14.05 23.08-31.38 23.08-17.328 0-31.379-8.594-31.379-23.08 0-14.487 14.05-26.225 31.38-26.225 17.329 0 31.38 11.738 31.38 26.225z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M86.277 59.607c-1.418 7.442-9.482 10.458-18.383 8.732-8.9-1.727-15.28-7.541-13.863-14.983 1.418-7.442 9.846-12.066 18.708-10.34 8.861 1.727 14.966 9.199 13.538 16.59z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#24282D",
    d: "M49.679 68.06c0 2.659-2.138 4.813-4.776 4.813-2.637 0-4.775-2.154-4.775-4.812 0-2.658 2.138-4.813 4.775-4.813 2.638 0 4.776 2.155 4.776 4.813zM81.768 72.873c2.637 0 4.775-2.154 4.775-4.812 0-2.658-2.138-4.813-4.775-4.813-2.638 0-4.776 2.155-4.776 4.813s2.138 4.812 4.776 4.812z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#231919",
    fillRule: "evenodd",
    d: "M82.5 77.5C81.588 76.647 81 75 81 75s-.588 1.647-1.5 2.5c-.633.633-1.5 1.354-1.5 2.5a3 3 0 0 0 6 0c0-1.146-.867-1.867-1.5-2.5z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#24282D",
    d: "M63.178 76.495c-3.939 0-6.991 2.203-6.991 4.961 0 .614.494 1.111 1.103 1.111s1.103-.497 1.103-1.11c0-1.49 2.235-2.79 4.785-2.79 2.55 0 4.795 1.3 4.795 2.79 0 .613.494 1.11 1.103 1.11s1.102-.497 1.102-1.11c0-2.76-3.072-4.962-7-4.962z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M38.11 115.173a25.252 25.252 0 0 0 6.587 17.017 62.687 62.687 0 0 0 36.972 0 25.253 25.253 0 0 0 6.578-17.017v-2.183H38.11v2.183z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2053AF",
    d: "M54.82 119.635a2.19 2.19 0 0 1 3.095.131l.25.272a2.19 2.19 0 0 1-.13 3.094l-7.342 6.746a2.19 2.19 0 0 1-3.094-.131l-.25-.272a2.19 2.19 0 0 1 .13-3.094l7.342-6.746zM65.214 120.002a2.19 2.19 0 0 1 3.095.126l.234.254a2.19 2.19 0 0 1-.125 3.095l-7.277 6.71a2.19 2.19 0 0 1-3.094-.125l-.235-.255a2.19 2.19 0 0 1 .125-3.095l7.277-6.71zM75.776 119.993a2.19 2.19 0 0 1 3.095.126l.235.254a2.19 2.19 0 0 1-.126 3.095l-7.277 6.71a2.19 2.19 0 0 1-3.094-.126l-.235-.254a2.19 2.19 0 0 1 .125-3.095l7.277-6.71z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 20,
    x: 64,
    y: 27,
    fill: "url(#h)",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 20,
    x: 54,
    y: 27,
    fill: "url(#i)",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 20,
    x: 44,
    y: 27,
    fill: "url(#j)",
    rx: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M106.076 0C93.884 0 84 9.79 84 21.865c0 7.734 2.556 14.029 8.668 17.93A8.496 8.496 0 0 1 91.343 48s6.483-1.323 7.936-5.305a22.27 22.27 0 0 0 6.797 1.035l-.21.058c12.189-.031 22.07-9.793 22.134-21.865C127.968 9.819 118.063.019 105.843 0h.233z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M105.546 25.818c-.795 0-1.25-.531-1.273-1.51l-.272-10.742c-.023-1.007.409-1.566 1.227-1.566h1.544c.818 0 1.25.56 1.227 1.566l-.272 10.742c-.023.979-.478 1.51-1.273 1.51h-.908zm-1.341 4.643v-1.118c0-1.007.432-1.539 1.25-1.539h1.09c.818 0 1.25.532 1.25 1.539v1.119c0 1.006-.432 1.538-1.25 1.538h-1.09c-.818 0-1.25-.532-1.25-1.538z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.163,
    x2: 0.163,
    y1: 8.01,
    y2: 135.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4EDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30.261,
    x2: 30.261,
    y1: 113.516,
    y2: 131.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A90FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1D6DCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 110.441,
    x2: 110.441,
    y1: 80.672,
    y2: 68.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#003CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A90FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 25.489,
    x2: 25.489,
    y1: 80.672,
    y2: 68.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#003CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A90FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 89.719,
    x2: 89.719,
    y1: 107.245,
    y2: 55.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#003CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A90FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 34.502,
    x2: 34.502,
    y1: 37.074,
    y2: 93.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5098E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 44.365,
    x2: 44.365,
    y1: 115.666,
    y2: 132.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5098E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 65.617,
    x2: 65.617,
    y1: 47,
    y2: 33.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#003CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A90FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 55.617,
    x2: 55.617,
    y1: 47,
    y2: 33.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#003CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A90FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 45.617,
    x2: 45.617,
    y1: 47,
    y2: 33.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001B8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#003CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A90FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 84,
    x2: 84,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F041B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsError1);
export default __webpack_public_path__ + "static/media/illustrations-error-1.de6928e678d62ddb0cf66f31ba372960.svg";
export { ForwardRef as ReactComponent };